import React from "react";
import {graphql} from "gatsby";
import parse from "html-react-parser";
import StructuredText from "../custom-structured-text-renderer";
import {Link} from "../../../../plugins/gatsby-plugin-atollon";
import FormComponent from "../../form";
import {RightArrow} from "../../icons";
import AnimationButton from "./animation-button";

const Contact = ({email, address, customerServicePhone, customerServiceFax, fax, title, richContent, phone, form}) => {

    return (
        <section className='contact'>
            <div className='contact__inner'>
                <div className='contact__details'>
                   <div className='contact__content' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
                       {title && <h1>{parse(title)}</h1>}
                       {richContent && <div><StructuredText data={richContent}/></div>}
                       <AnimationButton
                            className={`btn btn--animation`}
                            to='/find-a-distributor/'>
                            Find a Distributor
                            <RightArrow color='#ffffff'/>
                        </AnimationButton>
                   </div>

                    <div className='contact__contacts'>
                        {
                            customerServicePhone &&
                            <div className='contact__contact' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
                                <h4><strong>Customer Service</strong></h4>
                                <p>
                                    <strong>P</strong> <Link to='tel:1300661908'>{customerServicePhone}</Link><br/>
                                    <strong>E</strong> <Link to={`mailto:${email}`}>{email}</Link>
                                </p>
                            </div>
                        }
                        <div className='contact__contact contact__contact--empty' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease' />
                        {
                            address &&
                            <div className='contact__contact' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
                                <h4><strong>Head Office</strong></h4>
                                {address && <StructuredText data={address}/>}
                            </div>
                        }
                        {
                            email && phone &&
                            <div className='contact__contact' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
                                <p>
                                    <strong>P</strong> <Link to={`tel:${phone}`}>{phone}</Link>
                                </p>
                            </div>
                        }
                    </div>
                </div>

                <div className='contact__form'>
                    <div className='contacy__form-wrapper' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease' data-lenis-prevent>
                        <FormComponent form={form[0].form} />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Contact

export const query = graphql`
fragment ContactProps on DatoCmsContact {
  ... on DatoCmsContact {
    id
    email
    address {
      value
    }
    customerServicePhone
    customerServiceFax
    fax
    title
    richContent {
      value
    }
    phone
    form {
      form {
        ...FormProps
      }
    }
  }
}
`